import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authService } from "../services/api";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const ResetSenha = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const token = query.get("token") || "";

  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");
    if (!token) {
      setErro("link inválido ou expirado");
      return;
    }
    if (!novaSenha || !confirmarSenha) {
      setErro("nova senha e confirmação são obrigatórias");
      return;
    }
    if (novaSenha !== confirmarSenha) {
      setErro("nova senha e confirmação devem ser iguais");
      return;
    }
    if (novaSenha.length < 6) {
      setErro("nova senha deve ter pelo menos 6 caracteres");
      return;
    }
    try {
      setLoading(true);
      await authService.resetPassword({ token, novaSenha, confirmarSenha });
      setSucesso("senha redefinida com sucesso");
      setTimeout(() => navigate("/login"), 1500);
    } catch (error) {
      setErro(error.message || "erro ao redefinir senha");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ backgroundColor: "#f5f5f5" }}
    >
      <Card sx={{ width: 380 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Redefinir senha
          </Typography>
          {erro && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {erro}
            </Alert>
          )}
          {sucesso && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {sucesso}
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              label="Nova senha"
              type="password"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Confirmar senha"
              type="password"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              fullWidth
              margin="normal"
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading}
              sx={{ mt: 2 }}
            >
              {loading ? "Enviando..." : "Salvar nova senha"}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ResetSenha;
